import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tableCell:{
    border: 'none',
    color: '#757575',
    fontSize: '1rem',
    paddingRight: '50px',
    [theme.breakpoints.down("xs")]: {
      paddingRight: 0,
    }

  },
  tableHeader:{
    borderBottom: '2px solid #CECECE',
    color: '#505050',
    fontSize: '1rem',
    paddingRight: '50px',
    [theme.breakpoints.down("xs")]: {
      paddingRight: 0,
    }

  }
}));

const CardTable = (props) => {
  const classes = useStyles();
  return (
    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell classes={{root: classes.tableHeader}}>Posición</TableCell>
          <TableCell classes={{root: classes.tableHeader}}>Cantón</TableCell>
          <TableCell  align="right"  classes={{root: classes.tableHeader}} numeric>Personas Evacuadas</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.data.map((item, index) => {
          return (
            <TableRow key={item.id}>
              <TableCell classes={{root: classes.tableCell}} component="th" scope="row">
                {index+1}
              </TableCell>
              <TableCell classes={{root: classes.tableCell}} numeric>{item.name}</TableCell>
              <TableCell align="right" classes={{root: classes.tableCell}} numeric>{item.total}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default CardTable;
